import { DateTimeFormat } from '@classes/date-time-format';
import { EstimatorConfiguration } from '@classes/estimator/estimator-configuration';
import { ScaleAmountEvolutionGroup } from '@classes/parameters/scale-amount/scale-amount-evolution-group';
import { User } from '@classes/user/user';
import { ScenarioStatus } from '@enums/story-line/scenario-status.enum';
import { DateTime } from 'luxon';
import { Reconciliation } from './reconciliation';
import { Story } from './story';

export class Scenario {
    id: number;
    label: string;
    status: ScenarioStatus;

    baseScenario: Scenario;
    destinationReconciliations?: Reconciliation[];
    eventLastModifiedDate?: string;
    lastComputedDate?: string;
    lastModifiedBy?: User;
    referenceMonth?: string;
    scaleAmountEvolutionGroup?: ScaleAmountEvolutionGroup;
    sourceReconciliations?: Reconciliation[];
    story?: Story;
    estimatorConfiguration: EstimatorConfiguration;

    // Front only
    isLoading?: boolean;
    isSourceReconciliation?: boolean;

    constructor()
    constructor(label: string, story: Story, estimatorConfiguration: EstimatorConfiguration)
    constructor(label?: string, story?: Story, estimatorConfiguration?: EstimatorConfiguration) {
        this.label = label;
        this.story = story;
        this.estimatorConfiguration = estimatorConfiguration;
    }

    static fromObject(object: Scenario): Scenario {
        return Object.assign(new Scenario(), object);
    }

    get display(): string {
        return `${this.story.label} (${DateTime.fromISO(this.referenceMonth).toFormat(DateTimeFormat.monthDash)})`;
    }

    doesInclude(value: string): boolean {
        return this.some([this.story.label], value);
    }

    protected some(props: string[], value: string): boolean {
        return props.some(prop => prop.toLowerCase().includes(value));
    }
}
